// Copyright (c) 2023-2025 Matthias von Laer
// This file is part of Carsharing and is licensed under GNU Affero General Public License 3.0 or any later version. 

import React from 'react'
import {strings} from './Localization.js'
import './Login.css'

export function Login(props) {
  return (
      <div className="login">
        <img className="header-logo" src="HerzfeldSennrüti.svg" alt="Herzfeld Sennrüti"/>
        <h1>{strings.loginCarsharing}</h1>
          <button
            className="highlighted"
            onClick={() => props.onSubmit()}>
            {strings.loginAnmelden}
          </button>
      </div>
  )
}
